if (window.location.hostname === 'clis.app' || window.location.hostname === 'clfy.app') {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

export {}; // This ensures the file is treated as a module
